import TradeSpendReportGrid from "./TradeSpendReportGrid"
import TradeSpendReportSlicers from "./TradeSpendReportSlicers"

const TradeSpendReportTab = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col col-12">
                        <TradeSpendReportSlicers />
                    </div>

                    <div className="col col-12">
                        <TradeSpendReportGrid
                            gridHeight="70vh"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default TradeSpendReportTab